
import DropshippingLayout from '@marketplace/layouts/dropshipping.vue'

export default {
    name: 'DropshippingFullLayout',

    components: {
        DropshippingLayout,
    },
}
